import { useAuth } from '@clerk/nextjs';
import { Api } from '@firmable/contracts';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import * as Supabase from '@web/contracts/Supabase';
import axios from 'axios';

export interface ApiResponse {
  info: Api.Supabase.Customer.Info;
  success: true;
}

export interface Failure {
  message: string;
}

type Params = {
  refetchOnMount?: 'always' | boolean;
};

/**
 * React Query hook to fetch all the available addon credit plans
 * @returns ApiResponse | undefined
 */
const useCustomerInfo = ({ refetchOnMount }: Params) => {
  const { orgId } = useAuth();
  return useQuery<Supabase.Customer.Info, Failure>({
    queryKey: [Query.SupabaseKeys['customer-info'], { orgId }],
    refetchOnWindowFocus: false,
    refetchOnMount,
    placeholderData: (previousData) => previousData,
    retry: false,
    staleTime: Infinity, // need to figure out how to invalidate this as we need to fetch after sometime as the credits, views might change as customer uses the app
    queryFn: async () => {
      const response = await axios.get<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer/info`);
      return response.data.info;
    },
  });
};

export { useCustomerInfo };
